import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=00238794&"
import script from "./OrganizationInfo.vue?vue&type=script&lang=ts&"
export * from "./OrganizationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports